import AttachmentService from "../../services/api/attachmentService"

// Utility to convert base64 data URL to Blob
export const base64ToBlob = (base64Data) => {
  const parts = base64Data.split(',');
  const mime = parts[0].match(/:(.*?);/)[1];
  const byteString = atob(parts[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mime });
};

const convertBase64ToWebP = (base64Input) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Enable CORS if needed
    img.src = base64Input;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      // Convert to WebP at quality 0.8 (adjust as needed)
      const webpDataUrl = canvas.toDataURL('image/webp', 0.8);
      resolve(webpDataUrl);
    };

    img.onerror = (err) => {
      reject(new Error('Image loading error')); // or handle error as needed
    };
  })
};


// Function to replace src attributes using regex
export const replaceImageSrcRegex = (html, data) => {
  // Replace each <img> tag with a callback
  return html.replace(/<img\s+[^>]*src=["']([^"']+)["'][^>]*>/gi, (match, src) => {
    // If src is already an URL, ignore
    if (src.startsWith('http')) {
      return match;
    }
    // Find matching key in data
    const matchData = data.find(item => item.key === src);
    if (matchData) {
      // Replace src attribute in the original match
      return match.replace(src, matchData.path);
    }
    // If no match, return original
    return match;
  });
}


export const processHtmlWithImages = async (body, cardid, commentId, htmlString, image_reference) => {
  try {
    let resultJson = {};
    if (htmlString.includes('data:image/')) {
      let arrayOfImages = image_reference || [];
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const imgs = doc.querySelectorAll('img');

      let imageCount = 1;
      const uploadPromises = Array.from(imgs).map(async (img) => {
        const src = img.getAttribute('src');

        if (src.startsWith('data:')) {
          try {
            // const interSrc = src.split(';base64,')[1]; // FETCH base64 part only
            let webpBase64 = await convertBase64ToWebP(src)
            if (webpBase64) {
              // Convert base64 to Blob
              const blob = base64ToBlob(webpBase64);
              const formData = new FormData();
              formData.append('file', blob, 'image.webp');

              // Upload image to your server
              const response = await AttachmentService.richtextupload(body, cardid, commentId, formData);
              if (response?.data?.destination) {
                console.log('Image uploaded successfully:', response.data.destination);

                //const data = await response.json();

                // Replace src with URL from API
                //img.setAttribute('src', data.imageUrl);
                let currentTimeInMillis = new Date().getTime();
                const key = `richTextImageKey_${currentTimeInMillis}`;
                img.setAttribute('src', key);
                const imgReference = {};
                imgReference.key = key;
                imgReference.path = response.data.path_destination;
                imgReference.filename = response.data.filename;
                arrayOfImages.push(imgReference);
                imageCount++;
                return { success: true };
              } else {
                return { success: false, error: 'Image upload failed' };
              }
            } else {
              return { success: false, error: 'Image conversion failed' };
            }
          } catch (error) {
            return { success: false, error: error.message };
          }
        }
        return { success: true };
      });

      const results = await Promise.all(uploadPromises);
      const failedImages = results.filter(result => result && !result.success);
      if (failedImages.length > 0) {
        const errorDetails = failedImages.map(img => img.error).join(', ');
        throw new Error(`One or more images are corrupted or invalid: ${errorDetails}`);
      }

      resultJson.parsedHtml = doc.body.innerHTML;
      resultJson.images = arrayOfImages;
      // Serialize back to HTML
      return resultJson;
    } else {
      resultJson.parsedHtml = htmlString;
      resultJson.images = [];
      return resultJson;
    }
  } catch (error) {
    throw error;
  }

};